/**
 * SitePick front — ID 配列のサニタイズ（docs/06 §1 / §7）
 *
 * localStorage の内容も REST の入力も信用しない。
 * 正の整数だけを、追加順を保ったまま、重複を除いて、件数上限で切って返す。
 */

/**
 * 値が「1 以上の整数」か。
 *
 * @param {*} value
 * @returns {boolean}
 */
function isPositiveInt(value) {
  return typeof value === "number" && Number.isInteger(value) && value > 0;
}

/**
 * 任意の入力を「正の整数 ID の配列」に正規化する。
 *
 * - 配列でなければ空配列
 * - 文字列 / null / 真偽値 / 0 / 負数 / 小数 / NaN は除外
 * - 重複除去（初出の位置を維持）
 * - 先頭から max 件まで
 *
 * @param {*} raw
 * @param {number} [max=Infinity]
 * @returns {number[]}
 */
export function sanitizeIds(raw, max = Infinity) {
  if (!Array.isArray(raw)) {
    return [];
  }
  const seen = new Set();
  const out = [];
  for (const value of raw) {
    if (!isPositiveInt(value) || seen.has(value)) {
      continue;
    }
    seen.add(value);
    out.push(value);
    if (out.length >= max) {
      break;
    }
  }
  return out;
}

/**
 * 2 つの ID 配列が「同じ順序・同じ内容」か。
 *
 * @param {number[]} a
 * @param {number[]} b
 * @returns {boolean}
 */
export function sameIds(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i += 1) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}
